import { render, staticRenderFns } from "./EcografiaAddominaleViewComponent.vue?vue&type=template&id=5b7cf094"
import script from "./EcografiaAddominaleViewComponent.vue?vue&type=script&lang=js"
export * from "./EcografiaAddominaleViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports